import { render, staticRenderFns } from "./DummyProvider.vue?vue&type=template&id=e8c38a0a&scoped=true&"
import script from "./DummyProvider.vue?vue&type=script&lang=ts&"
export * from "./DummyProvider.vue?vue&type=script&lang=ts&"
import style0 from "./DummyProvider.vue?vue&type=style&index=0&id=e8c38a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c38a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VImg,VLayout,VTextField})
